import { render, staticRenderFns } from "./PaymentStep.vue?vue&type=template&id=96d62886&scoped=true"
import script from "./PaymentStep.vue?vue&type=script&lang=js"
export * from "./PaymentStep.vue?vue&type=script&lang=js"
import style0 from "./PaymentStep.vue?vue&type=style&index=0&id=96d62886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d62886",
  null
  
)

export default component.exports